import { useState } from "react";
import { AnswerOnlineFormEditWidgetStyled } from "./styled";
import { portalService } from "apiServices";
import Linkify from "react-linkify";
import { IMG_PATH } from "utils/constants/imgPath";
import momentTZ from "moment-timezone";
import { useSelector } from "react-redux";
import { Displays, Forms, Modals } from "components";
import { toast } from "react-toastify";

const AnswerOnlineFormEditWidget = ({
  id,
  question_list_id,
  data,
  onSuccess,
}) => {
  const authenRedux = useSelector((state) => state.authenRedux);
  const permission = !authenRedux
    ? false
    : authenRedux?.permission.find((e) => e.menu_key === "activity-form");

  const [_isBgLoading, _setIsBgLoading] = useState(false);
  const [_renderModal, _setRenderModal] = useState(false);

  const _handleCloseModal = () => {
    _setRenderModal(false);
  };

  const _renderData = (e) => {
    if (!e) {
      return "-";
    } else {
      switch (e.type) {
        case "3":
          return !e.answer ? (
            "-"
          ) : (
            <a
              href={IMG_PATH + e.answer}
              target="_blank"
              rel="noopener noreferrer"
            >
              Link
            </a>
          );
        case "5":
          return !e.answer
            ? "-"
            : momentTZ(
                e.answer
                // "YYYY-MM-DD"
              )
                .tz("Asia/Bangkok")
                .format("DD/MM/YYYY");
        default:
          return (
            <Linkify
              componentDecorator={(decoratedHref, decoratedText, key) => (
                <a target="blank" href={decoratedHref} key={key}>
                  {decoratedText}
                </a>
              )}
            >
              {e.answer}
            </Linkify>
          );
      }
    }
  };

  const _handleClickEdit = () => {
    _setRenderModal(
      <Forms.QuickTestActivityForm
        initialValue={data}
        permission={permission}
        onSubmit={_handleSubmit}
      />
    );
  };

  const _handleSubmit = async (values) => {
    _setIsBgLoading(true);
    const bodyFormData = new FormData();
    bodyFormData.append("activity_form_history_id", id);
    bodyFormData.append("question_list_id", question_list_id);
    bodyFormData.append("question_id", data._id);
    bodyFormData.append("type", data.type);
    if (data.type === "3") {
      bodyFormData.append("image", values.answer[0]);
    } else {
      bodyFormData.append("answer", values.answer);
    }
    let res = await portalService.POST_ACTIVITY_FORM_ANSWER_EDIT(bodyFormData);
    if (res && res.status === 200) {
      onSuccess();
      _setIsBgLoading(false);
      _handleCloseModal();
      toast.success("Edit Success");
    } else {
      _setIsBgLoading(false);
      _handleCloseModal();
      toast.error("Edit fail");
    }
  };
  return (
    <>
      <AnswerOnlineFormEditWidgetStyled>
        <Displays.BGLoading visible={_isBgLoading} />
        <div className="awof_edit" onClick={_handleClickEdit}>
          {_renderData(data)}
        </div>
      </AnswerOnlineFormEditWidgetStyled>
      <Modals.BodyEmpty
        isShowModal={_renderModal}
        onCloseModal={_handleCloseModal}
      >
        {_renderModal}
      </Modals.BodyEmpty>
    </>
  );
};

export default AnswerOnlineFormEditWidget;
